// Путь: D:\QR\QR-WEB\dashboard\src\components\User\VoucherPreview.jsx
// Версия: 2.2.0 - Added dary.one branding
// Дата: 14.12.2025

import React, { useRef, useEffect } from 'react';
import './VoucherPreview.css';

const THEME_MAP = {
  'default': '/templates/default.png',
  'обычный': '/templates/default.png',
  'birthday': '/templates/birthday.png',
  'день рождения': '/templates/birthday.png',
  'love': '/templates/love.png',
  'с любовью': '/templates/love.png',
  'thanks': '/templates/thanks.png',
  'спасибо': '/templates/thanks.png',
  'gift': '/templates/gift.png',
  'подарок': '/templates/gift.png',
  'congrats': '/templates/congrats.png',
  'поздравляю': '/templates/congrats.png',
  'coffee': '/templates/coffee.png',
  'на кофе': '/templates/coffee.png',
  'lunch': '/templates/lunch.png',
  'на обед': '/templates/lunch.png',
  'travel': '/templates/travel.png',
  'путешествие': '/templates/travel.png',
  'gaming': '/templates/gaming.png',
  'на игры': '/templates/gaming.png',
  'shopping': '/templates/shopping.png',
  'шоппинг': '/templates/shopping.png',
  'newyear': '/templates/newyear.png',
  'новый год': '/templates/newyear.png',
};

const THEME_TITLES = {
  'default': 'QR Money',
  'обычный': 'QR Money',
  'birthday': 'Happy Birthday!',
  'день рождения': 'Happy Birthday!',
  'love': 'With Love',
  'с любовью': 'With Love',
  'thanks': 'Thank You!',
  'спасибо': 'Thank You!',
  'gift': 'A Gift For You',
  'подарок': 'A Gift For You',
  'congrats': 'Congratulations!',
  'поздравляю': 'Congratulations!',
  'coffee': 'Coffee Time',
  'на кофе': 'Coffee Time',
  'lunch': 'Lunch Time',
  'на обед': 'Lunch Time',
  'travel': 'Bon Voyage!',
  'путешествие': 'Bon Voyage!',
  'gaming': 'Game On!',
  'на игры': 'Game On!',
  'shopping': 'Shopping Spree',
  'шоппинг': 'Shopping Spree',
  'newyear': 'Happy New Year!',
  'новый год': 'Happy New Year!',
};

const getTemplateUrl = (themeId) => {
  if (!themeId) return '/templates/default.png';
  const key = themeId.toLowerCase();
  return THEME_MAP[key] || '/templates/default.png';
};

const getThemeTitle = (themeId) => {
  if (!themeId) return 'QR Money';
  const key = themeId.toLowerCase();
  return THEME_TITLES[key] || 'QR Money';
};

const VoucherPreview = ({ amount, code, templateTitle, size = 150, onClick }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    const s = size;
    const title = getThemeTitle(templateTitle);

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      ctx.drawImage(img, 0, 0, s, s);
      
      const center = s / 2;
      
      ctx.fillStyle = '#ffffff';
      ctx.textAlign = 'center';
      ctx.shadowColor = 'rgba(0,0,0,0.5)';
      ctx.shadowBlur = 3;
      
      // Заголовок темы
      ctx.font = 'bold ' + (s * 0.09) + 'px Arial';
      ctx.fillText(title, center, s * 0.3);
      
      // Сумма DAR
      ctx.font = 'bold ' + (s * 0.14) + 'px Arial';
      ctx.fillText(parseFloat(amount).toFixed(2) + ' DAR', center, s * 0.55);
      
      // Брендинг dary.one
      ctx.shadowBlur = 2;
      ctx.font = (s * 0.06) + 'px Arial';
      ctx.fillStyle = 'rgba(255,255,255,0.7)';
      ctx.fillText('🎁 → dary.one', center, s * 0.78);
      
      // Код
      ctx.font = (s * 0.07) + 'px monospace';
      ctx.fillStyle = 'rgba(255,255,255,0.7)';
      ctx.fillText(code || '', center, s * 0.92);
    };
    
    img.onerror = () => {
      const gradient = ctx.createLinearGradient(0, 0, s, s);
      gradient.addColorStop(0, '#7C3AED');
      gradient.addColorStop(1, '#A78BFA');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, s, s);
      
      const center = s / 2;
      ctx.fillStyle = '#ffffff';
      ctx.textAlign = 'center';
      ctx.shadowColor = 'rgba(0,0,0,0.5)';
      ctx.shadowBlur = 3;
      
      // Заголовок темы
      ctx.font = 'bold ' + (s * 0.09) + 'px Arial';
      ctx.fillText(title, center, s * 0.3);
      
      // Сумма DAR
      ctx.font = 'bold ' + (s * 0.14) + 'px Arial';
      ctx.fillText(parseFloat(amount).toFixed(2) + ' DAR', center, s * 0.55);
      
      // Брендинг dary.one
      ctx.shadowBlur = 2;
      ctx.font = (s * 0.06) + 'px Arial';
      ctx.fillStyle = 'rgba(255,255,255,0.7)';
      ctx.fillText('🎁 → dary.one', center, s * 0.78);
      
      // Код
      ctx.font = (s * 0.07) + 'px monospace';
      ctx.fillStyle = 'rgba(255,255,255,0.7)';
      ctx.fillText(code || '', center, s * 0.92);
    };
    
    img.src = getTemplateUrl(templateTitle);

  }, [amount, code, templateTitle, size]);

  return (
    <canvas 
      ref={canvasRef} 
      width={size} 
      height={size} 
      className="voucher-preview-canvas"
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    />
  );
};

export default VoucherPreview;